// Generated by ReScript, PLEASE EDIT WITH CARE

import * as AccountingVendor from "../../modules/AccountingVendor.res.js";

let baseRoute = "/accounting";

function configurationRoute(shopId, vendor) {
  return baseRoute + "/" + shopId + "/configuration/" + AccountingVendor.toLowercaseString(vendor);
}

export {
  baseRoute,
  configurationRoute,
}
/* No side effect */
